const JWT_KEY = 'jwt_token';

const storeJwt = (jwt: string) => {
  localStorage.setItem(JWT_KEY, jwt);
};

const getJwt = () => {
  return localStorage.getItem(JWT_KEY);
};

export { storeJwt, getJwt };
